import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Link, Redirect, useHistory, useParams } from 'react-router-dom';
import Notiflix from 'notiflix';
import { FaRegAddressCard } from 'react-icons/all';
import Input from '../../components/Input';

import {
  Container,
  Background,
  Content,
  ContainerFooter,
  BemVindo,
  BemVindoMobile,
  ContentMobile,
  ModalContent,
  ModalButton,
  ButtonLogin,
  ContainerInfoSvg,
  ContainerLogoW,
  VirtualCardButton,
  FooterContainer,
  CookiesButton,
} from './styles';
import getValidationErrors from '../../utils/getValidationErrors';
import Select, { SelectHandles } from '../../components/Select';
import { GrupowSvg, InfoSvg, CardUnimed } from '../../components/Svg';
import { useAuth } from '../../hooks/auth';
import api from '../../services/api/api';
import {
  portalMedicosLogin,
  resolveExchangeUrl,
} from '../../services/api/portalMedicos';
import { requestLocation } from '../../utils/location';
import Modal2 from '../../components/Modal2';
import { ObjectGetValueOfKey } from '../../utils/formatt';
import { getParams } from '../../utils/Url';
import Button from '../../components/Button';

const typeUserOptions = [
  { value: '1', title: 'Beneficiário' },
  { value: '2', title: 'Empresa' },
  { value: '3', title: 'PA Digital' },
  { value: '4', title: 'Portal Médico' },
];

const Login: React.FC = () => {
  const { login, hasPrimaryToken, loginJoinIn, user } = useAuth();
  const { params } = useParams<{ params: string }>();
  const history = useHistory();
  const typeUserRef = useRef<SelectHandles>(null);
  const formRef = useRef<FormHandles>(null);
  const [typeUser, setTypeUser] = useState('1');
  const { hashJoinIn } = getParams();
  const paramsPage = new URLSearchParams(window.location.search);
  const paParam = paramsPage.get('padigital');
  const portalMedicosParam = paramsPage.has('portalmedicos');

  const placeholder = () => {
    switch (typeUser) {
      case '1':
        return 'CPF ou Carteirinha';
      case '2':
        return 'Usuário';
      case '3':
        return 'Carteirinha';
      case '4':
        return 'CPF';
      default:
        return '';
    }
  };
  const handleToogleModal = useCallback(async () => {
    try {
      Notiflix.Loading.circle();
      const { data } = await api.get(
        '/gw/translation?key=termo-de-cookies&language=PT',
      );
      const { content } = data;
      const text = `${ObjectGetValueOfKey(content, 'termo-de-cookies')}`;

      Modal2.Generic({
        closable: false,
        children: (
          <>
            {/* <ModalTitle>Aviso de Cookies</ModalTitle> */}
            <ModalContent dangerouslySetInnerHTML={{ __html: text }} />
            <ModalButton
              onClick={() => Modal2.Close()}
              modal
              outlined
              autoWidth
            >
              Fechar
            </ModalButton>
          </>
        ),
      });
    } catch (err) {
      Notiflix.Notify.failure(
        'Ops... Estamos com algum erro no servidor... tente mais tarde...',
      );
    } finally {
      Notiflix.Loading.remove();
    }
  }, []);

  const handleTypeUserChange = useCallback((value) => {
    setTypeUser(value);
    formRef.current?.setFieldValue('document', '');
    if (value === '2') {
      history.push('/login?redirect=/');
    }
  }, []);

  const handleFormSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          document:
            // eslint-disable-next-line no-nested-ternary
            typeUser === '1'
              ? Yup.number()
                  .required('Informe seu CPF ou número da Carteirinha')
                  .typeError('Informe seu CPF ou número da Carteirinha')
              : // eslint-disable-next-line no-nested-ternary
              typeUser === '3'
              ? Yup.string()
                  .required('Informe o número da Carteirinha')
                  .typeError('Informe o número da Carteirinha')
                  .min(17, 'O Campo deve ter no mínimo 17 caracteres')
              : typeUser === '4'
              ? Yup.string()
                  .required('Informe seu CPF')
                  .typeError('Informe seu CPF')
                  .min(11, 'Informe um CPF válido')
              : Yup.string().required('Informe seu usuário'),
          password:
            typeUser !== '3'
              ? Yup.string().required('Informe sua senha')
              : Yup.string().notRequired(),
        });
        await schema.validate(data, {
          abortEarly: false,
        });

        Notiflix.Loading.circle();
        if (typeUser === '4') {
          const {
            success,
            message,
            errors,
            data: content,
          } = await portalMedicosLogin(data.document, data.password);

          if (!success || !content?.exchangeUrl) {
            formRef.current?.setErrors(
              (errors || []).reduce(
                (acc, error) => ({
                  ...acc,
                  [error.field === 'cpf' ? 'document' : error.field]:
                    error.message,
                }),
                {},
              ),
            );
            Notiflix.Notify.failure(
              message || 'Não foi possível acessar o Portal Médico.',
            );
            return;
          }

          window.location.href = resolveExchangeUrl(content.exchangeUrl);
        } else if (typeUser !== '3') {
          const toSend =
            typeUser === '2'
              ? { user: data.document, password: data.password, typeUser }
              : { ...data, typeUser };
          const success = await login(toSend);
          if (success.valid) {
            if (success.mustUpdatePassword === true) {
              history.push('/alterar-senha');
            } else {
              const getRedirect = window.location.href.split('?redirect=')[1];
              if (getRedirect !== 'undefined') {
                setTimeout(() => {
                  if (getRedirect === 'alterar-senha') {
                    history.push(`/alterar-senha`);
                  } else {
                    history.push(`/${getRedirect}`);
                  }
                }, 200);
              } else {
                history.push('/');
              }
            }
          }
        } else {
          const response = await api.get<{
            userUnimedType: string;
            portalLogin: string;
            portalUrl?: string;
          }>(
            `/digital-emergency-care/beneficiary-type-consultation?cardNUmber=${data.document}`,
          );

          const { userUnimedType, portalLogin, portalUrl } = response.data;

          if (portalUrl && userUnimedType !== 'B') {
            const open = window.open(portalUrl, '_blank');
            if (open) {
              Notiflix.Notify.success('Acesse o P.A. Digital');
            }
          } else {
            switch (portalLogin) {
              case 'S':
                setTypeUser('1');
                formRef.current?.setFieldValue('document', data.document);
                typeUserRef.current?.setValue('', '1');
                history.push(`login?redirect=/pa-digital`);
                Notiflix.Notify.success(
                  'Faça login e acesse o P.A. Digital através do portal',
                );
                break;
              case 'N':
                Notiflix.Notify.info('Cadastre-se para acessar o P.A. Digital');
                history.push(`/cadastre-se?padigital=${data.document}`);
                break;
              default:
                break;
            }
          }
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        } else if (
          err.response?.data?.message &&
          err.response?.status !== 503
        ) {
          formRef.current?.setFieldError(
            'document',
            'Usuario e/ou senha inválidos',
          );
          Notiflix.Notify.failure(err.response.data.message);
        } else {
          Notiflix.Notify.failure(
            'Ops... Não conseguimos nos conectar ao servidor. Por favor, tente novamente mais tarde.',
          );
        }
      } finally {
        Notiflix.Loading.remove();
      }
    },
    [typeUser, login, history],
  );

  const verifyHomologation = useCallback(async () => {
    const { hash } = getParams();
    const ipUser = window.ipify;
    if (hash) {
      try {
        Notiflix.Loading.circle('Autenticando...');
        await api.get(
          `/user/activation-by-clicking-on-email?uid=${hash}&originIp=${ipUser}`,
        );
        Modal2.Success({
          closable: true,
          title: 'Perfeito!',
          text: 'Você foi homologado com sucesso!',
        });
      } catch (err) {
        if (err.response?.data?.message) {
          Modal2.Failure({
            closable: true,
            subtitle: 'Ops... algo deu errado.',
            text: err.response.data.message,
            children: (
              <div>
                <Button
                  type="button"
                  onClick={() => {
                    window.location.search = '';
                  }}
                >
                  Ok
                </Button>
              </div>
            ),
          });
        } else {
          Modal2.Failure({
            closable: true,
            subtitle: 'Ops... algo deu errado.',
            text: 'Algo aconteceu com seu Link de Homologação. Não conseguimos prosseguir.',
            children: (
              <div>
                <Button
                  type="button"
                  onClick={() => {
                    window.location.search = '';
                  }}
                >
                  Ok
                </Button>
              </div>
            ),
          });
        }
      } finally {
        Notiflix.Loading.remove();
        // window.location.search = '';
      }
    }
  }, []);

  const getJoinJWT = async (hash: string) => {
    try {
      const success = await loginJoinIn(hash);
      if (success) {
        history.push('/');
      }
    } catch (err) {
      if (err.response?.data?.message) {
        Modal2.Failure({
          closable: true,
          subtitle: 'Ops... algo deu errado.',
          text: err.response.data.message,
        });
      } else {
        Modal2.Failure({
          closable: true,
          subtitle: 'Ops... algo deu errado.',
          text: 'Algo aconteceu na sua autenticação. Não conseguimos prosseguir.',
        });
      }
    }
  };

  useEffect(() => {
    const paramsHash = getParams();

    const ipUser = window.ipify;

    if (hasPrimaryToken) {
      verifyHomologation();
      if (paramsHash.hashJoinIn) {
        getJoinJWT(paramsHash.hashJoinIn);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPrimaryToken]);

  useEffect(() => {
    const userType = localStorage.getItem('@userType');
    if (!userType) {
      return;
    }

    const title = typeUserOptions.find(
      (option) => option.value === userType,
    )?.title;

    if (!title) {
      return;
    }

    typeUserRef.current?.setValue(title, userType);

    setTypeUser(userType);
  }, []);

  useEffect(() => {
    if (paParam) {
      setTypeUser('3');
      typeUserRef.current?.setValue('P.A. Digital', '3');
      console.log(typeUserRef.current?.value);
    }
  }, [paParam]);

  useEffect(() => {
    if (portalMedicosParam) {
      setTypeUser('4');
      typeUserRef.current?.setValue('Portal Médico', '4');
    }
  }, [portalMedicosParam]);

  // Pede a localização assim que o perfil "Portal Médico" é selecionado, para
  // que a resposta já esteja disponível no envio (header `X-Location`).
  useEffect(() => {
    if (typeUser === '4') {
      requestLocation();
    }
  }, [typeUser]);

  const bemVindoDesktop = useMemo(() => {
    if (typeUser === '1') {
      return (
        <BemVindo>
          Bem-vindo <br />
          ao portal do <br />
          beneficiário <br />
        </BemVindo>
      );
    }
    if (typeUser === '2') {
      return (
        <BemVindo>
          Bem-vindo <br />
          ao portal Unimed <br />
          Empresas
        </BemVindo>
      );
    }
    if (typeUser === '3') {
      return (
        <BemVindo>
          Bem-vindo ao <br />
          P.A. Digital
        </BemVindo>
      );
    }
    if (typeUser === '4') {
      return (
        <BemVindo>
          Bem-vindo ao <br />
          portal médico
        </BemVindo>
      );
    }
    return <></>;
  }, [typeUser]);

  const bemVindoMobile = useMemo(() => {
    if (typeUser === '1') {
      return (
        <BemVindoMobile>
          Bem-vindo ao
          <br />
          portal do beneficiário
        </BemVindoMobile>
      );
    }
    if (typeUser === '2') {
      return (
        <BemVindoMobile>
          Bem-vindo ao portal
          <br />
          Unimed Empresas
        </BemVindoMobile>
      );
    }
    if (typeUser === '3') {
      return (
        <BemVindoMobile>
          Bem-vindo ao <br />
          P.A. Digital
        </BemVindoMobile>
      );
    }
    if (typeUser === '4') {
      return (
        <BemVindoMobile>
          Bem-vindo ao <br />
          portal médico
        </BemVindoMobile>
      );
    }
    return <></>;
  }, [typeUser]);

  return (
    <Container>
      <Background
        background={
          paramsPage.get('redirect') === '/pa-digital' ? '3' : typeUser
        }
      >
        {bemVindoDesktop}
        <ContainerLogoW>
          <a
            href="https://www.grupow.com.br/"
            title="GrupoW Softwares para Internet"
            target="_blanck"
          >
            Desenvolvido por <strong>GrupoW Softwares para Internet</strong>
            <GrupowSvg />
          </a>
        </ContainerLogoW>
      </Background>
      <Content>
        <Form ref={formRef} onSubmit={handleFormSubmit}>
          <ContentMobile
            background={
              paramsPage.get('redirect') === '/pa-digital' ? '3' : typeUser
            }
          >
            <h2>
              Selecione seu perfil <br />e digite seus dados
            </h2>
            {bemVindoMobile}
            <Select
              name="typeuser"
              ref={typeUserRef}
              changeCallback={handleTypeUserChange}
              options={typeUserOptions}
            >
              {typeUser === '1' && (
                <ContainerInfoSvg>
                  <InfoSvg />
                  <div>
                    <CardUnimed />
                  </div>
                </ContainerInfoSvg>
              )}
            </Select>
            <Input
              name="document"
              placeholder={placeholder()}
              masks={
                // eslint-disable-next-line no-nested-ternary
                typeUser === '1'
                  ? ['999.999.999-99', '9 999 999999999999 9']
                  : // eslint-disable-next-line no-nested-ternary
                  typeUser === '3'
                  ? ['9 999 999999999999 9']
                  : typeUser === '4'
                  ? ['999.999.999-99']
                  : undefined
              }
            />
            {typeUser !== '3' && (
              <Input name="password" type="password" placeholder="Senha" />
            )}
          </ContentMobile>

          <ButtonLogin type="submit">Entrar</ButtonLogin>
          <Link to="/esqueci-minha-senha">Esqueci minha senha</Link>
        </Form>

        <ContainerFooter>
          <FooterContainer>
            <CookiesButton
              type="button"
              onClick={handleToogleModal}
              className={typeUser !== '1' ? '-center' : ''}
            >
              Aviso de Cookies
            </CookiesButton>
            <VirtualCardButton to="/cartao-virtual-externo">
              <FaRegAddressCard size={30} />
              Cartão Virtual
            </VirtualCardButton>
            {typeUser === '1' && (
              <div>
                <span>É a sua primeira vez aqui?</span>
                <br />
                <Link to="/cadastre-se">Cadastre-se</Link>
              </div>
            )}
          </FooterContainer>

          <ContainerLogoW className="mobile">
            <a
              href="https://www.grupow.com.br/"
              title="GrupoW Softwares para Internet"
              target="_blanck"
            >
              Desenvolvido por <strong>GrupoW Softwares para Internet</strong>
              <GrupowSvg />
            </a>
          </ContainerLogoW>
        </ContainerFooter>
      </Content>
    </Container>
  );
};

export default Login;
